/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface UserClient {
  client: {
    /** @example "my_login" */
    login: string;
    /** @example "ООО Гарант плюс" */
    name: string;
  };
  /** @example "Бухгалтер" */
  role: string;
  permissions: UserClientPermission[];
}

export enum UserClientPermission {
  View = "view",
  Suggest = "suggest",
  Order = "order",
  Laximo = "laximo",
}

export type Client = {
  login: string;
  /** @example "ООО Гарант плюс" */
  name: string;
  deliveryDayType: "calendar" | "work";
  status: "enabled" | "disabled";
  roles: ("suggest" | "orders")[];
  /** @example "Бухгалтер" */
  role: string;
  permissions: UserClientPermission[];
  settings: UserClientSettings;
} & {
  balance: {
    availableAmount: number;
    expiredDebt: number;
    minimumPaymentTomorrow: number;
  };
  acceptedOffer?: any;
  personalDataAgreement?: any;
};

export interface UserClientSettingsPut {
  visibleExtraCharge: number;
  visibleExtraChargeView: ("suggest" | "basket")[];
}

export interface UserClientSettings {
  visibleExtraCharge: number;
  visibleExtraChargeView: ("suggest" | "basket")[];
}

export interface Proposal {
  id: string;
  basketItemId?: string;
  brand: string;
  brandName: string;
  priceList?: string;
  article: string;
  articleName: string;
  description: string;
  quantity: number;
  price: number;
  isAnalog: boolean;
  multiplicity: number;
  delivery?: {
    expected: any;
    guaranteed: any;
  };
  /** @example {"official":true} */
  flags: Record<string, boolean>;
  rating: number;
  returnCondition: string;
  isFavorite: boolean;
  isBanned: boolean;
  /** @format date-time */
  expiresAt: string;
}

export interface Basket {
  status: "actual" | "stale" | "unavailable";
  total: number;
  items: (Proposal & {
    status: "actual" | "stale" | "unavailable";
    itemsCnt: number;
    comment: string;
    /** @format date-time */
    createdAt: string;
  })[];
}

export interface RefreshedBasket {
  total: number;
  statusPrev: "actual" | "stale" | "unavailable";
  statusNew: "actual" | "stale" | "unavailable";
  items: Record<
    string,
    {
      prev: Proposal & {
        status: "actual" | "stale" | "unavailable";
        itemsCnt: number;
        comment: string;
        /** @format date-time */
        createdAt: string;
      };
      new: Proposal & {
        status: "actual" | "stale" | "unavailable";
        comment: string;
        /** @format date-time */
        createdAt: string;
      };
      changedFields: string[];
    }
  >;
}

/**
 * Словарь в виде идентификатор - объект с количеством позиций и комментарием.  Если количество позиций 0, то позиция удаляется. Обновляются только позиции, которые переданы
 * @example {"proposal-identifier":{"itemsCnt":600,"comment":"метка"}}
 */
export type BasketPatch = Record<
  string,
  {
    itemsCnt: number;
    comment?: string;
  }
>;

export interface OrderPost {
  basketItems: string[];
}

export interface OrderPostResult {
  success: boolean;
  errors: (
    | "finance.available.not_enough"
    | "basket.stale"
    | "basket.unavailable"
    | "offer.not_accepted"
    | "offer.personal_data_agreement_not_accepted"
  )[];
  warnings?: ("finance.debt.expired_exists" | "finance.required_payment")[];
  orderId?: string;
  finance?: {
    paymentType: "post_payment" | "prepaid_shipment" | "prepaid_receiving" | "retail";
    orderTotal?: number;
    available: number;
    requiredPayment?: number;
    debt?: any;
  };
  basket?: {
    stale?: string[];
    unavailable?: string[];
  };
}

export interface OrderSearch {
  limit: number;
  offset: number;
  filter?: {
    /** @format date-time */
    dateFrom?: string;
    /** @format date-time */
    dateTo?: string;
    /** @format date-time */
    deliveryDateFrom?: string;
    /** @format date-time */
    deliveryDateTo?: string;
    statusIn?: string[];
    refIdIn?: string[];
    brandNameIn?: string[];
    articleIn?: string[];
    priceFrom?: number;
    priceTo?: number;
    sumFrom?: number;
    sumTo?: number;
    hasComment?: boolean;
    hideArchive?: boolean;
  };
  sort?: {
    direction?: "asc" | "desc";
    field?: "date" | "delivery" | "status_date" | "status" | "ref_id" | "price" | "sum";
  }[];
}

export interface OrderSearchDownload {
  limit?: number;
  offset?: number;
  filter?: {
    /** @format date-time */
    dateFrom?: string;
    /** @format date-time */
    dateTo?: string;
    /** @format date-time */
    deliveryDateFrom?: string;
    /** @format date-time */
    deliveryDateTo?: string;
    statusIn?: string[];
    refIdIn?: string[];
    brandNameIn?: string[];
    articleIn?: string[];
    priceFrom?: number;
    priceTo?: number;
    sumFrom?: number;
    sumTo?: number;
    hasComment?: boolean;
  };
  sort?: {
    direction?: "asc" | "desc";
    field?: "date" | "delivery" | "status_date" | "status" | "ref_id" | "price" | "sum";
  }[];
}

export interface Order {
  /** @format date-time */
  createdAt: string;
  deliveryInfo: {
    expected: any;
    guaranteed: any;
  };
  /** @example "00001" */
  refId: string;
  refType: "sequence" | "client-prefix" | "var";
  /** @example {"created":{"id":"created","name":"Новый","qty":4,"createdAt":"2019-10-12T07:20:50.52Z"}} */
  status: {
    id: string;
    name: string;
    qty: number;
    /** @format date-time */
    createdAt: string;
  };
  /** @example {"official":true} */
  flags: Record<string, boolean>;
  return: "limited" | "impossible" | "possible" | "unknown";
  /** @example "10-25142-SX_радиатор системы охлаждения!\\ Volvo S40/V40 1.6-2.0 16V 95>" */
  articleName: string;
  /** @example "10-25142-SX" */
  article: string;
  /** @example "Stellox" */
  brandName: string;
  priceList?: string;
  quantity: number;
  /** @example 7854.23 */
  price: number;
  /** @example 7854.23 */
  sum: number;
  comment: string;
  staleMarks?: {
    passive?: boolean;
    archived?: boolean;
  };
  refusal?: {
    availableCount: number;
    requested: any[];
    finished: any[];
  };
  returnState: {
    /** Доступен ли возврат */
    available: boolean;
    /** Были ли возвраты по заказу */
    exists: boolean;
  };
  priceListPreference: {
    isFavorite: boolean;
    isBanned: boolean;
  };
}

export interface Balance {
  currentBalance: number;
  availableForOrder: number;
  debt?: {
    total: number;
    expired: number;
    expiredDays: number;
  };
  upcomingPayments?: {
    tomorrow: number;
    closest: {
      amount: number;
      /** @format date-time */
      date: string;
    };
  };
  orders: {
    unpaid: number;
    inProgress: number;
    ready: number;
  };
  deniedFlags: ("order" | "shipment")[];
}

export interface QrPaymentPost {
  /** Amount to pay */
  amount: number;
}

export interface QrPaymentPostResult {
  success: boolean;
  qrData: string;
  qrId: string;
  ttl?: number;
  payload: string;
}

export interface Notification {
  /**
   * @format uuid
   * @example "fa493db8-ecb1-4152-ace2-e244841906ba"
   */
  id: string;
  type: "refusal_finished" | "return_status" | "documents_received";
  client: string;
  user: string;
  payload: NotificationFinishRefusal | NotificationReturnStatus | NotificationDocumentReceived;
  /** @format date-time */
  readAt?: string;
  /** @format date-time */
  createdAt: string;
}

export interface NotificationFinishRefusal {
  /**
   * Единиц отказа принято, число как строка
   * @pattern ^\d+$
   * @example "1"
   */
  accepted: string;
  /**
   * Всего единиц в отказе, число как строка
   * @pattern ^\d+$
   * @example "1"
   */
  count: string;
  /**
   * Единиц отказа отклонено, число как строка
   * @pattern ^\d+$
   * @example "0"
   */
  declined: string;
  orderItemPk: string;
  orderItemPkType: "sequence" | "client-prefix" | "var";
  /**
   * @format date-time
   * @example "2025-08-04T18:35:31+03:00"
   */
  time: string;
}

export interface NotificationReturnStatus {
  previous:
    | "new"
    | "processing"
    | "declined"
    | "accepted"
    | "returned"
    | "paid"
    | "wait_expertise"
    | "on_expertise"
    | "returned_after_expertise";
  current:
    | "new"
    | "processing"
    | "declined"
    | "accepted"
    | "returned"
    | "paid"
    | "wait_expertise"
    | "on_expertise"
    | "returned_after_expertise";
  returnId: number;
  comment?: string;
  orderItemPk?: string;
  orderItemPkType?: "sequence" | "client-prefix" | "var";
}

export interface NotificationDocumentReceived {
  docType: "scheduled_payment" | "reconciliation_report";
  count?: number;
  /** @format uuid */
  requestId?: string;
}

export interface OrderReturn {
  id: number;
  status:
    | "new"
    | "processing"
    | "declined"
    | "accepted"
    | "returned"
    | "paid"
    | "wait_expertise"
    | "on_expertise"
    | "returned_after_expertise";
  /**
   * Время установления статуса
   * @format date-time
   */
  statusTime: string;
  statusComment?: string;
  statusHistory: {
    status:
      | "new"
      | "processing"
      | "declined"
      | "accepted"
      | "returned"
      | "paid"
      | "wait_expertise"
      | "on_expertise"
      | "returned_after_expertise";
    /** @format date-time */
    time: string;
    comment?: string;
  }[];
  /**
   * Дата создания заявки на возврат
   * @format date-time
   */
  createdTime: string;
  /**
   * Дата ответа на заявку
   * @format date-time
   */
  resolvedTime?: string;
  /**
   * Максимальная дата ответа на заявку
   * @format date-time
   */
  maxResolvedTime?: string;
  /**
   * Максимальная время на возврат
   * @format date-time
   */
  returnBeforeTime?: string;
  orderItem: {
    refType: "var" | "client-prefix" | "sequence";
    refId: string;
    brandName?: string;
    article?: string;
    articleName?: string;
  };
  reason: any;
  count: number;
  sum: number;
  contacts: {
    name: string;
    phone: string;
  };
  comment?: string;
  payload: object;
  /** @format date-time */
  cancelDeadline: string;
}

export interface OrderReturnPatch {
  status?: "canceled";
  /**
   * Формируется JSON на основе schema, ключами выступает uniqueKey, а значения устанавливаются в зависимости от типа:
   *   - photos_block, {uniqueKey level 1}.{uniqueKey level 2} - массив ссылок на изображения
   *   - text, {uniqueKey} - строка
   *
   * Например, есть причина возврата:
   * ```json
   * {
   *   "key": "example_reason",
   *   "name": "Пример причины возврата",
   *   "schema": [
   *     {
   *       "type": "photos_blocks",
   *       "uniqueKey": "examplePhotoBlock",
   *       "title": "Добавьте фото, чтобы подтвердить причину возврата",
   *       "required": true,
   *       "maxCount": 10,
   *       "blocks": [
   *         {
   *           "uniqueKey": "package",
   *           "title": "Упаковка",
   *           "required": true
   *         },
   *         {
   *           "uniqueKey": "face",
   *           "title": "Лицо",
   *           "required": true
   *         }
   *       ]
   *     },
   *     {
   *       "type": "text",
   *       "uniqueKey": "code",
   *       "title": "Код товара",
   *       "required": true,
   *       "placeholder": "Впишите код товара из дополнительной накладной"
   *     }
   *   ],
   *   "responseDuration": 48
   * }
   * ```
   *
   * При отправке на сервер должен быть сформирован такой payload
   * ```json
   * ...
   * "payload": {
   *     "examplePhotoBlock": {
   *         "package": [
   *             "https://static.atez.ru/bucket1/hash.png"
   *         ],
   *         "face": [
   *             "https://static.atez.ru/bucket1/hash.png"
   *         ]
   *     },
   *     "code": "123456"
   * }
   * ...
   * ```
   */
  payload?: object;
}

export interface DocumentRequestPost {
  docType: "scheduled_payment" | "reconciliation_report" | "document_flow";
  format: "xls" | "pdf";
  payload: any;
}

export type DocumentRequest = DocumentRequestPost & {
  /** @format uuid */
  id: string;
  name: string;
  status: "queue" | "in_progress" | "processed";
  /** @format date-time */
  createdAt: string;
  documents?: any[];
};

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "https://in.atez.ru/api/ut/us" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title User Gateway API
 * @version 0.0.1
 * @baseUrl https://in.atez.ru/api/ut/us
 *
 * API для фронтенда
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  contactUs = {
    /**
     * @description Send contact us info
     *
     * @tags Utils
     * @name ContactUsCreate
     * @summary Send contact us info
     * @request POST:/contact-us
     * @secure
     */
    contactUsCreate: (
      data: {
        name: string;
        phone: string;
        email: string;
        message?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/contact-us`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  login = {
    /**
     * @description Login
     *
     * @tags Login
     * @name LoginCreate
     * @summary Login
     * @request POST:/login
     * @secure
     */
    loginCreate: (
      data: {
        type?: "password" | "token";
        login?: string;
        password?: string;
        token?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /**
           * @format jwt
           * @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c"
           */
          access_token: string;
          /**
           * In seconds
           * @example 600
           */
          expires_in: string;
        },
        any
      >({
        path: `/login`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),
  };
  generatePassword = {
    /**
     * @description Generate password
     *
     * @tags Login
     * @name GeneratePasswordList
     * @summary Generate password
     * @request GET:/generate-password
     * @secure
     */
    generatePasswordList: (params: RequestParams = {}) =>
      this.request<
        {
          password: string;
        },
        any
      >({
        path: `/generate-password`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  changePassword = {
    /**
     * @description Change password
     *
     * @tags Login
     * @name ChangePasswordCreate
     * @summary Change password
     * @request POST:/change-password
     * @secure
     */
    changePasswordCreate: (
      data: {
        currentPassword: string;
        newPassword: string;
        newPasswordConfirm: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/change-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  resendPassword = {
    /**
     * @description Resend user password
     *
     * @tags Login
     * @name ResendPasswordCreate
     * @summary Resend user password
     * @request POST:/resend-password
     * @secure
     */
    resendPasswordCreate: (
      data: {
        login: string;
        email: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/resend-password`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  token = {
    /**
     * @description Get client specific token
     *
     * @tags Login
     * @name TokenCreate
     * @summary Get client specific token
     * @request POST:/token
     * @secure
     */
    tokenCreate: (
      data: {
        client: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /**
           * Contains extra fields: aud = client.login, permissions = user_client.permissions
           * @format jwt
           * @example "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c"
           */
          access_token: string;
          /**
           * In seconds
           * @example 600
           */
          expires_in: string;
        },
        any
      >({
        path: `/token`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.UrlEncoded,
        format: "json",
        ...params,
      }),
  };
  client = {
    /**
     * @description Get user clients
     *
     * @tags User Client
     * @name ClientList
     * @summary Get user clients
     * @request GET:/client
     * @secure
     */
    clientList: (
      query?: {
        /** @example "my_lo" */
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: UserClient;
        },
        any
      >({
        path: `/client`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get client
     *
     * @tags Client
     * @name ClientDetail
     * @summary Get client
     * @request GET:/client/{login}
     * @secure
     */
    clientDetail: (login?: string, params: RequestParams = {}) =>
      this.request<Client, any>({
        path: `/client/${login}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Set up client settings
     *
     * @tags Client
     * @name SettingsUpdate
     * @summary Set up client settings
     * @request PUT:/client/{login}/settings
     * @secure
     */
    settingsUpdate: (data: UserClientSettingsPut, login?: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/client/${login}/settings`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Add client preference
     *
     * @tags Client Preferences
     * @name PreferenceCreate
     * @summary Add client preference
     * @request POST:/client/{login}/preference
     * @secure
     */
    preferenceCreate: (login: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/client/${login}/preference`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get client preferences
     *
     * @tags Client Preferences
     * @name PreferenceList
     * @summary Get client preferences
     * @request GET:/client/{login}/preference
     * @secure
     */
    preferenceList: (
      login: string,
      query?: {
        type?: "favorite_price_list" | "banned_price_list";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @example 1 */
          total?: number;
          items?: any[];
        },
        any
      >({
        path: `/client/${login}/preference`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update client preference
     *
     * @tags Client Preferences
     * @name PreferencePartialUpdate
     * @summary Update client preference
     * @request PATCH:/client/{login}/preference/{id}
     * @secure
     */
    preferencePartialUpdate: (login: string, id: string, data: any, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/client/${login}/preference/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete client preference
     *
     * @tags Client Preferences
     * @name PreferenceDelete
     * @summary Delete client preference
     * @request DELETE:/client/{login}/preference/{id}
     * @secure
     */
    preferenceDelete: (login: string, id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/client/${login}/preference/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Get balance
     *
     * @tags Balance
     * @name BalanceList
     * @summary Get balance
     * @request GET:/client/{login}/balance
     * @secure
     */
    balanceList: (login?: string, params: RequestParams = {}) =>
      this.request<Balance, any>({
        path: `/client/${login}/balance`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  suggest = {
    /**
     * @description Suggest
     *
     * @tags Suggest
     * @name SuggestCreate
     * @summary Suggest
     * @request POST:/suggest
     * @secure
     */
    suggestCreate: (
      data: {
        brand: string;
        article: string;
        useAnalogs: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          asyncKey?: string;
          items: Proposal[];
        },
        any
      >({
        path: `/suggest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get async suggestion proposals
     *
     * @tags Suggest
     * @name AsyncProposalsDetail
     * @summary Get async suggestion proposals
     * @request GET:/suggest/async-proposals/{key}
     * @secure
     */
    asyncProposalsDetail: (key: string, params: RequestParams = {}) =>
      this.request<
        {
          total: number;
          state: "in_progress" | "done" | "clear";
          items: Proposal[];
        },
        any
      >({
        path: `/suggest/async-proposals/${key}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  suggestBrand = {
    /**
     * @description Suggest brand by article
     *
     * @tags Suggest
     * @name SuggestBrandList
     * @summary Suggest brand by article
     * @request GET:/suggest-brand
     * @secure
     */
    suggestBrandList: (
      query: {
        article: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: {
            /** @example "Stellox" */
            name: string;
            /** @example 4095 */
            code: string;
          }[];
        },
        any
      >({
        path: `/suggest-brand`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  basketDownload = {
    /**
     * @description Download basket
     *
     * @tags Basket
     * @name BasketDownloadList
     * @summary Download basket
     * @request GET:/basket-download
     * @secure
     */
    basketDownloadList: (params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/basket-download`,
        method: "GET",
        secure: true,
        ...params,
      }),
  };
  basket = {
    /**
     * @description Get current basket
     *
     * @tags Basket
     * @name BasketList
     * @summary Get current basket
     * @request GET:/basket
     * @secure
     */
    basketList: (params: RequestParams = {}) =>
      this.request<Basket, any>({
        path: `/basket`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Clear basket
     *
     * @tags Basket
     * @name BasketDelete
     * @summary Clear basket
     * @request DELETE:/basket
     * @secure
     */
    basketDelete: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/basket`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Update current basket
     *
     * @tags Basket
     * @name BasketPartialUpdate
     * @summary Update current basket
     * @request PATCH:/basket
     * @secure
     */
    basketPartialUpdate: (data: BasketPatch, params: RequestParams = {}) =>
      this.request<Basket, any>({
        path: `/basket`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Clear basket
     *
     * @tags Basket
     * @name RefreshCreate
     * @summary Clear basket
     * @request POST:/basket/refresh
     * @secure
     */
    refreshCreate: (
      data: {
        /** Массив идентификаторов предложение которые нужно актуализировать */
        items: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<RefreshedBasket, any>({
        path: `/basket/refresh`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  order = {
    /**
     * @description Create order
     *
     * @tags Order
     * @name OrderCreate
     * @summary Create order
     * @request POST:/order
     * @secure
     */
    orderCreate: (data: OrderPost, params: RequestParams = {}) =>
      this.request<OrderPostResult, any>({
        path: `/order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Update order item
     *
     * @tags Order
     * @name OrderPartialUpdate
     * @summary Update order item
     * @request PATCH:/order/{refType}/{refId}
     * @secure
     */
    orderPartialUpdate: (
      refType: "sequence" | "client-prefix" | "var",
      refId: string,
      data: {
        comment: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/order/${refType}/${refId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Create refusal
     *
     * @tags Order
     * @name RefusalCreate
     * @summary Create refusal
     * @request POST:/order/{refType}/{refId}/refusal
     * @secure
     */
    refusalCreate: (
      refType: "sequence" | "client-prefix" | "var",
      refId: string,
      data: {
        count: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/order/${refType}/${refId}/refusal`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get order return state. Это подготовка к возврату, для отрисовки формы
     *
     * @tags Order Return
     * @name ReturnStateList
     * @summary Get order return state
     * @request GET:/order/{refType}/{refId}/return-state
     * @secure
     */
    returnStateList: (refType: "sequence" | "client-prefix" | "var", refId: string, params: RequestParams = {}) =>
      this.request<
        {
          items: any[];
        },
        any
      >({
        path: `/order/${refType}/${refId}/return-state`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create return
     *
     * @tags Order Return
     * @name ReturnCreate
     * @summary Create return
     * @request POST:/order/{refType}/{refId}/return
     * @secure
     */
    returnCreate: (
      refType: "sequence" | "client-prefix" | "var",
      refId: string,
      data: any,
      params: RequestParams = {},
    ) =>
      this.request<OrderReturn, any>({
        path: `/order/${refType}/${refId}/return`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  orderReturnReason = {
    /**
     * @description Get order return reasons
     *
     * @tags Order Return Reason
     * @name OrderReturnReasonList
     * @summary Get order return reasons
     * @request GET:/order-return-reason
     * @secure
     */
    orderReturnReasonList: (params: RequestParams = {}) =>
      this.request<
        {
          total: number;
          items: any[];
        },
        any
      >({
        path: `/order-return-reason`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  orderReturn = {
    /**
     * @description Update return
     *
     * @tags Order Return
     * @name OrderReturnPartialUpdate
     * @summary Update return
     * @request PATCH:/order-return/{id}
     * @secure
     */
    orderReturnPartialUpdate: (id: number, data: OrderReturnPatch, params: RequestParams = {}) =>
      this.request<OrderReturn, any>({
        path: `/order-return/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  orderReturnSearch = {
    /**
     * @description Get orders returns
     *
     * @tags Order Return
     * @name OrderReturnSearchCreate
     * @summary Get orders returns
     * @request POST:/order-return-search
     * @secure
     */
    orderReturnSearchCreate: (
      data: {
        limit: number;
        offset: number;
        /** @format date-time */
        createdFrom?: string;
        /** @format date-time */
        createdTo?: string;
        statusIn?: (
          | "new"
          | "processing"
          | "declined"
          | "accepted"
          | "returned"
          | "paid"
          | "wait_expertise"
          | "on_expertise"
          | "returned_after_expertise"
        )[];
        status?:
          | "new"
          | "processing"
          | "declined"
          | "accepted"
          | "returned"
          | "paid"
          | "wait_expertise"
          | "on_expertise"
          | "returned_after_expertise";
        sumFrom?: number;
        sumTo?: number;
        /** @format date-time */
        returnBeforeFrom?: string;
        /** @format date-time */
        returnBeforeTo?: string;
        refId?: string;
        refIdIn?: string[];
        idIn?: number[];
        reasonKeyIn?: string[];
        hasComment?: boolean;
        sort?: {
          direction: "asc" | "desc";
          field: "created_time" | "status_time" | "return_before_time" | "id" | "ref_id" | "sum" | "resolved_time";
        }[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: OrderReturn[];
        },
        any
      >({
        path: `/order-return-search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  orderReturnSearchFilter = {
    /**
     * @description Search order return filters
     *
     * @tags Order Return
     * @name OrderReturnSearchFilterCreate
     * @summary Search order return filters
     * @request POST:/order-return-search-filter
     * @secure
     */
    orderReturnSearchFilterCreate: (
      data: {
        limit: number;
        offset: number;
        filter: "status" | "id" | "ref_id" | "reason_key";
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: {
            key: string;
            displayValue: string;
          }[];
        },
        any
      >({
        path: `/order-return-search-filter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  orderReturnImageUpload = {
    /**
     * @description Get orders returns
     *
     * @tags Order Return
     * @name OrderReturnImageUploadCreate
     * @summary Get orders returns
     * @request POST:/order-return-image-upload
     * @secure
     */
    orderReturnImageUploadCreate: (
      data: {
        /** @format binary */
        image?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          url: string;
        },
        any
      >({
        path: `/order-return-image-upload`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  orderSearch = {
    /**
     * @description Search orders
     *
     * @tags Order
     * @name OrderSearchCreate
     * @summary Search orders
     * @request POST:/order-search
     * @secure
     */
    orderSearchCreate: (data: OrderSearch, params: RequestParams = {}) =>
      this.request<
        {
          total: number;
          items: Order[];
        },
        any
      >({
        path: `/order-search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  orderStatSearch = {
    /**
     * @description Search orders stat
     *
     * @tags Order
     * @name OrderStatSearchCreate
     * @summary Search orders stat
     * @request POST:/order-stat-search
     * @secure
     */
    orderStatSearchCreate: (data: OrderSearch, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/order-stat-search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  orderSearchDownload = {
    /**
     * @description Search orders and download
     *
     * @tags Order
     * @name OrderSearchDownloadCreate
     * @summary Search orders and download
     * @request POST:/order-search-download
     * @secure
     */
    orderSearchDownloadCreate: (data: OrderSearchDownload, params: RequestParams = {}) =>
      this.request<string, any>({
        path: `/order-search-download`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  orderSearchFilterValue = {
    /**
     * @description Get value list (50 max) for orders filter
     *
     * @tags Order
     * @name OrderSearchFilterValueDetail
     * @summary Get value list (50 max) for orders filter
     * @request GET:/order-search-filter-value/{key}
     * @secure
     */
    orderSearchFilterValueDetail: (
      key: "status" | "ref_id" | "brand_name" | "article",
      query?: {
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          values: {
            id: string;
            name: string;
          }[];
        },
        any
      >({
        path: `/order-search-filter-value/${key}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  laximo = {
    /**
     * No description
     *
     * @tags Laximo
     * @name LaximoList
     * @summary Proxying request
     * @request GET:/laximo
     * @secure
     */
    laximoList: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/laximo`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Laximo
     * @name LaximoCreate
     * @summary Proxying request
     * @request POST:/laximo
     * @secure
     */
    laximoCreate: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/laximo`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  qrPayment = {
    /**
     * @description Create QR payment
     *
     * @tags QR Payments
     * @name QrPaymentCreate
     * @summary Create QR payment
     * @request POST:/qr-payment
     * @secure
     */
    qrPaymentCreate: (data: QrPaymentPost, params: RequestParams = {}) =>
      this.request<QrPaymentPostResult, any>({
        path: `/qr-payment`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Check QR payment status
     *
     * @tags QR Payments
     * @name StatusCreate
     * @summary Check QR payment status
     * @request POST:/qr-payment/status
     * @secure
     */
    statusCreate: (
      data: {
        qrId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          success: boolean;
          status: "NotStarted" | "Received" | "InProgress" | "Accepted" | "Rejected";
        },
        any
      >({
        path: `/qr-payment/status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  unreadNotifications = {
    /**
     * @description Get unread notification
     *
     * @tags Notification
     * @name UnreadNotificationsList
     * @summary Get unread notification
     * @request GET:/unread-notifications
     * @secure
     */
    unreadNotificationsList: (params: RequestParams = {}) =>
      this.request<
        {
          total: number;
          items: Notification[];
        },
        any
      >({
        path: `/unread-notifications`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  readNotifications = {
    /**
     * @description Read notifications
     *
     * @tags Notification
     * @name ReadNotificationsCreate
     * @summary Read notifications
     * @request POST:/read-notifications
     * @secure
     */
    readNotificationsCreate: (
      data: {
        /**
         * @format uuid
         * @example "23e4567-e89b-12d3-a456-426655440000"
         */
        id?: string;
        /**
         * Прочитать все уведомления полученные до
         * @format date-time
         * @example "2025-08-04T18:35:31+03:00"
         */
        to?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/read-notifications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  paymentSchedule = {
    /**
     * @description Get client payment schedule
     *
     * @tags Payment Schedule
     * @name PaymentScheduleList
     * @summary Get client payment schedule
     * @request GET:/payment-schedule
     * @secure
     */
    paymentScheduleList: (params: RequestParams = {}) =>
      this.request<
        {
          rows: {
            /**
             * @format date
             * @example "2020-12-31"
             */
            paymentDate: string;
            sum: number;
            paid: number;
            status: "paid" | "awaiting" | "late";
            documents: any[];
          };
        },
        any
      >({
        path: `/payment-schedule`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  documentRequest = {
    /**
     * @description Create document request
     *
     * @tags Document Request
     * @name DocumentRequestCreate
     * @summary Create document request
     * @request POST:/document-request
     * @secure
     */
    documentRequestCreate: (data: DocumentRequestPost, params: RequestParams = {}) =>
      this.request<DocumentRequest, any>({
        path: `/document-request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  documentRequestSearch = {
    /**
     * @description Search document requests
     *
     * @tags Document Request
     * @name DocumentRequestSearchCreate
     * @summary Search document requests
     * @request POST:/document-request-search
     * @secure
     */
    documentRequestSearchCreate: (
      data: {
        type?: "scheduled_payment" | "reconciliation_report";
        status?: "queue" | "in_progress" | "processed";
        limit?: number;
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total: number;
          items: DocumentRequest[];
        },
        any
      >({
        path: `/document-request-search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  markDocumentSeen = {
    /**
     * @description Mark document seen
     *
     * @tags Document
     * @name MarkDocumentSeenCreate
     * @summary Mark document seen
     * @request POST:/mark-document-seen
     * @secure
     */
    markDocumentSeenCreate: (
      data: {
        ids: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/mark-document-seen`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  documentFlowSearchFilter = {
    /**
     * @description Search document flow filters
     *
     * @tags Document Flow
     * @name DocumentFlowSearchFilterCreate
     * @summary Search document flows
     * @request POST:/document-flow-search-filter
     * @secure
     */
    documentFlowSearchFilterCreate: (
      data: {
        type: "type" | "docNum" | "refId";
        q?: string;
        limit: number;
        offset: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total?: number;
          items?: {
            key: string;
            displayValue: string;
          }[];
        },
        any
      >({
        path: `/document-flow-search-filter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  documentFlowSearch = {
    /**
     * @description Search document flows
     *
     * @tags Document Flow
     * @name DocumentFlowSearchCreate
     * @summary Search document flows
     * @request POST:/document-flow-search
     * @secure
     */
    documentFlowSearchCreate: (
      data: {
        /** @format date-time */
        dateFrom?: string;
        /** @format date-time */
        dateTo?: string;
        type?: "sale" | "payment" | "return" | "return_money" | "debt_adjustment";
        docNum?: string;
        orderRefId?: string;
        limit: number;
        offset: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          total?: number;
          items?: any[];
        },
        any
      >({
        path: `/document-flow-search`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  actualOffer = {
    /**
     * @description Get actual offer
     *
     * @tags Offer
     * @name ActualOfferList
     * @summary Get actual offer
     * @request GET:/actual-offer
     * @secure
     */
    actualOfferList: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/actual-offer`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  offer = {
    /**
     * @description Get offer by revision
     *
     * @tags Offer
     * @name OfferDetail
     * @summary Get offer by revision
     * @request GET:/offer/{revision}
     * @secure
     */
    offerDetail: (revision: string, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/offer/${revision}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  clientOffer = {
    /**
     * @description Accept client offer
     *
     * @tags Client Offer
     * @name ClientOfferUpdate
     * @summary Accept client offer
     * @request PUT:/client-offer/{revision}
     * @secure
     */
    clientOfferUpdate: (
      revision: string,
      data: {
        withPersonalData?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/client-offer/${revision}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  clientAcceptPersonalDataAgreement = {
    /**
     * @description Accept personal data agreement
     *
     * @tags Client Offer
     * @name ClientAcceptPersonalDataAgreementUpdate
     * @summary Accept personal data agreement
     * @request PUT:/client-accept-personal-data-agreement
     * @secure
     */
    clientAcceptPersonalDataAgreementUpdate: (data: object, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/client-accept-personal-data-agreement`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
